<template>
  <div class="box full h-full">
    <div class="box-header">
      <h6 class="title">
        Products
      </h6>
      <div class="w-full flex justify-end">
        <button v-if="!edit" @click="startEdit()" class="w-6 ml-2">
          <img class="w-full" src="@/assets/icons/edit.svg" />
        </button>
      </div>
    </div>
    <div class="content">
      <table class="default-table">
        <thead>
          <tr>
            <th></th>
            <th class="text-left" style="min-width: 80px;">SKU</th>
            <th class="text-left">Line</th>
            <th class="text-left">Description</th>
            <th class="text-left">Brand</th>
            <th class="text-left">Price</th>
            <th class="text-left">quantity</th>
            <th class="text-left">total</th>
            <th v-if="edit">action</th>
          </tr>
        </thead>
        <tbody>
          <ProductLine
            v-for="(item, index) in editingProducts"
            :key="index + '-' + renderId"
            :product="item"
            :edit="edit"
            :priceLevel="priceLevel"
            @removeItem="removeItem"
            @removeItemById="removeItemById"
            @confirmEditing="updateProduct"
            @viewProduct="viewProduct"
          />
        </tbody>
      </table>
      <NewProductLine
        class="w-full"
        v-if="editingProducts && !loading"
        :edit="edit"
        :priceLevel="priceLevel"
        :products="editingProducts"
        :departmentCode="departmentCode"
        @addProduct="addProduct"
      />
      <template v-if="edit">
        <div class="w-full flex flex-row p-2">
          <div class="w-full text-right mt-1 flex-grow">
            <button class="btn-success-button" @click="saveChanges()">
              <template v-if="!loading">
                Confirm
              </template>
              <template v-else>
                Saving...
              </template>
            </button>
            <button
              class="ml-2 btn-dark-button"
              @click="revertChanges()"
              v-if="!loading"
            >
              Cancel
            </button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import ProductLine from "@/components/order/ProductLine.vue";
import NewProductLine from "@/components/order/NewProductLine.vue";
import {
  getCustomerCart,
  updateCartItems
} from "@/api/store/CustomersService.js";
export default {
  name: "ShoppingCartItems",
  components: {
    ProductLine,
    NewProductLine
  },
  props: {
    priceLevel: {
      type: String,
      required: true
    },
    customerId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      edit: false,
      products: [],
      editingProducts: [],
      newProduct: null,
      renderId: 0,
      loading: false
    };
  },
  computed: {
    departmentCode() {
      const activeDepartment = this.$store.getters[
        "general/getActiveDepartment"
      ];
      if (activeDepartment && activeDepartment.code) {
        return activeDepartment.code;
      }

      const routeDepartmentCode = this.$route?.params?.departmentCode;
      if (routeDepartmentCode && routeDepartmentCode.toLowerCase() !== "all") {
        return routeDepartmentCode;
      }

      return "all";
    },
    originalProductsFormated() {
      return this.products.map(product => {
        return {
          sku: product.nkrCode,
          price: product.price,
          qty: product.quantity
        };
      });
    },
    editingProductsFormated() {
      return this.editingProducts.map(product => {
        return {
          sku: product.nkrCode,
          price: product.price,
          qty: product.quantity
        };
      });
    }
  },
  mounted() {
    this.loadProducts();
  },
  methods: {
    viewProduct(nkrCode) {
      this.$emit("viewProduct", nkrCode);
    },
    async loadProducts() {
      let originalProducts = await getCustomerCart(this.customerId).catch(
        () => {
          this.error = "Error Loading Products.";
        }
      );
      this.products = originalProducts.map(product => {
        return {
          nkrCode: product.sku,
          image: product.image,
          description: product.description,
          brand: product.brand,
          price: product.price,
          quantity: product.qty
        };
      });
      this.editingProducts = [...this.products];
    },
    startEdit() {
      this.edit = true;
    },
    revertChanges() {
      this.edit = false;
      this.editingProducts = [...this.products];
      this.renderId++;
    },
    addProduct(newProduct) {
      this.editingProducts.push(newProduct);
    },
    saveChanges() {
      if (!this.loading) {
        this.loading = true;
        const productsToDelete = this.originalProductsFormated.filter(
          product => {
            return !this.editingProductsFormated.some(
              editingProduct => editingProduct.sku == product.sku
            );
          }
        );
        const productsToAdd = this.editingProductsFormated.filter(
          editingProduct => {
            return !this.originalProductsFormated.some(
              product => product.sku == editingProduct.sku
            );
          }
        );
        const productsToUpdate = this.editingProductsFormated.filter(
          editingProduct => {
            return this.originalProductsFormated.find(product => {
              return (
                product.sku == editingProduct.sku &&
                (editingProduct.qty != product.qty ||
                  editingProduct.price != product.price)
              );
            });
          }
        );
        const cartUpdates = {
          productsToDelete,
          productsToAdd,
          productsToUpdate
        };
        if (
          productsToDelete.length === 0 &&
          productsToAdd.length === 0 &&
          productsToUpdate.length === 0
        ) {
          this.revertChanges();
          this.loading = false;
          return;
        }
        updateCartItems(this.customerId, cartUpdates)
          .then(() => {
            this.$toast.open({
              message: "cart Updated",
              type: "success",
              position: "top-right"
            });
            this.edit = false;
            this.loadProducts();
          })
          .catch(() => {
            this.$toast.open({
              message: "Error updating cart",
              type: "error",
              position: "top-right"
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    removeItem(code) {
      this.editingProducts = this.editingProducts.filter(product => {
        return product.nkrCode != code;
      });
    },
    removeItemById(productId) {
      this.editingProducts = this.editingProducts.filter(product => {
        return product.productId != productId;
      });
    },
    updateProduct(newProduct) {
      const byProductId = newProduct.productId
        ? this.editingProducts.findIndex(
            product => product.productId == newProduct.productId
          )
        : -1;
      const index =
        byProductId >= 0
          ? byProductId
          : this.editingProducts.findIndex(
              product => product.nkrCode == newProduct.nkrCode
            );

      if (newProduct.quantity == 0) {
        if (newProduct.productId) {
          this.removeItemById(newProduct.productId);
        } else {
          this.removeItem(newProduct.nkrCode);
        }
        return;
      }

      if (index >= 0) {
        this.editingProducts[index] = {
          ...this.editingProducts[index],
          ...newProduct
        };
      }
    }
  }
};
</script>
